import { createFileRoute } from '@tanstack/react-router'
import { DashboardPage } from '@/pages/dashboard'
import PageLoading from '@/components/PageLoading'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/dashboard/'
)({
  component: DashboardPage,
  pendingComponent: () => (
    <div className='w-screen'>
      <PageLoading />
    </div>
  ),
  pendingMs: 0,
  pendingMinMs: 200,
})
